export default "__VITE_ASSET__C9HTy4HX__"